<!--  -->
<template>
  <div class="TeamDetails">
    <h1>{{ name }}</h1>
    <h2>{{ sign }}</h2>
    <div class="fenge"></div>
    <div v-html="msg">
      {{ aaa }}
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      id: 0,
      msg: "",
      name: "",
      sign: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //1.文章详情
    get_detail() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_article",
          article_id: that.id,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.msg = obj.data.msg;
            that.name = obj.data.title;
            that.sign = obj.data.sign;
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var v = parseUrl();
    this.id = v["id"];
    this.get_detail();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};

function parseUrl() {
  var url = location.href;
  var i = url.indexOf("?");
  if (i == -1) return;
  var querystr = url.substr(i + 1);
  var arr1 = querystr.split("&");
  var arr2 = new Object();
  for (i in arr1) {
    var ta = arr1[i].split("=");
    arr2[ta[0]] = ta[1];
  }
  return arr2;
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.TeamDetails {
  width: $main-width;
  margin: 60px auto;
  h1 {
    color: #333;
    font-size: 1.3rem;
  }
  h2 {
    font-size: 1.1rem;
    color: #999;
    margin-top: 6px;
  }
  .fenge {
      margin: 10px 0 40px;
    width: 970px;
    height: 1px;
    background: #e6e6e6;
  }
}
@media screen and (max-width: $main-width) {
  .TeamDetails {
    width: 100%;
    padding: 0 10px;
    .fenge {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/team/TeamDetails.vue